import allPagesConfig from './allPagesConfig';
import ForgotPasswordPageConfig from './auth/forgot-password/ForgotPasswordPageConfig';
import Login2PageConfig from './auth/login-2/Login2PageConfig';
// import ResetPasswordPageConfig from './auth/reset-password/ResetPasswordPageConfig';
import TokenConfig from './auth/token/TokenConfig';
import ResetPassword2PageConfig from './auth/reset-password-2/ResetPassword2PageConfig';
import Error404LoggedOutPageConfig from './errors/404-logged-out/Error404LoggedOutPageConfig';
import PrivacyPolicyConfig from './privacy-policy/PrivacyPolicyConfig';
import BTWhatsappConfig from './auth/back-to-whatsapp/BTWhatsappConfig';
import WhatsAppMobileConfig from './whatsapp-mobile/WhatsAppMobileConfig';

let pagesConfigs = [];
let userAcl = localStorage.getItem('user_acl');

if (userAcl !== null) {
	userAcl = JSON.parse(userAcl);

	pagesConfigs = allPagesConfig.map(config => {
		let check = false;
		if (config && config.routes && config.routes.length) {
			for (let i = 0; i < config.routes.length; i++) {
				const route = config.routes[i];

				if (userAcl[`FRONT:${route.path}`]) {
					check = true;
					break;
				}
			}
		}

		if (check) {
			return config;
		}
	});

	pagesConfigs = pagesConfigs.filter(el => el);

	// WhatsAppMobileConfig is a self-contained sample-data UI demo (no backend/socket
	// calls), always public — not gated by any ACL. FuseAuthorization also re-checks
	// `user_acl['FRONT:<pathname>']` directly against localStorage on every navigation,
	// independent of pagesConfigs, so the key is synthesized here too or a logged-in
	// staff member without this ACL entry would still get redirected away.
	pagesConfigs.push(WhatsAppMobileConfig);

	if (!userAcl['FRONT:/apps/whatsapp']) {
		userAcl['FRONT:/apps/whatsapp'] = 1;
		localStorage.setItem('user_acl', JSON.stringify(userAcl));
	}
} else {
	pagesConfigs = [
		Login2PageConfig,
		PrivacyPolicyConfig,
		ResetPassword2PageConfig,
		Error404LoggedOutPageConfig,
		// ResetPasswordPageConfig,
		ForgotPasswordPageConfig,
		TokenConfig,
		BTWhatsappConfig,
		WhatsAppMobileConfig
	];
}

export default pagesConfigs;
